import React, { useState, useEffect, useRef } from 'react'
import { Routes, Route, useLocation } from "react-router-dom";
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import LandingPage from './components/LandingPage/LandingPage';
import FaqPage from './components/FaqPage/FaqPage';
import AboutPage from './components/AboutPage/AboutPage';
import ContactPage from './components/ContactPage/ContactPage';
import ShopPage from './components/ShopPage/ShopPage';
import ProductDetail from './components/ProductDetail/ProductDetail';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import Refund from './components/PrivacyPolicy/Refund';
import Terms from './components/PrivacyPolicy/Terms';
import Login from './components/Login/Login';
import SignUp from './components/SignUp/SignUp';
import WhishListPage from './components/WhishListPage/WhishListPage';
import BlogDetailsPage from './components/BlogDetailsPage/BlogDetailsPage';
import BlogPage from './components/BlogPage/BlogPage';
import CartPage from './components/CartPage/CartPage';
import CheckoutPage from './components/CheckoutPage/CheckoutPage';
import CommingSoon from './components/CommingSoon/CommingSoon';
import EmptyCartPage from './components/EmptyCartPage/EmptyCartPage';
import EmptyWishlist from './components/EmptyCartPage/EmptyWishlist';
import ErrorPage from './components/ErrorPage/ErrorPage';
import { Bars } from 'react-loader-spinner';

import './App.scss';

const ROUTE_LOADER_MS = 450;

function App() {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);
  const [routeLoading, setRouteLoading] = useState(false);
  const isInitialRoute = useRef(true);

  useEffect(() => {
    setTimeout(() => {
      setData('Data loaded!');
      setIsLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (isInitialRoute.current) {
      isInitialRoute.current = false;
      return undefined;
    }
    setRouteLoading(true);
    const id = window.setTimeout(() => setRouteLoading(false), ROUTE_LOADER_MS);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  console.log(data);
  const showLoader = IsLoading || routeLoading;

  return (
    <>
      {showLoader && (
        <div className="loader" aria-busy="true" aria-live="polite">
          <Bars
            height="100px"
            width="100px"
            radius={5}
            color="#7AAAF5"
            ariaLabel="Loading page"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          />
        </div>
      )}
      <Header
        WishProductNum={6}
        AddProductNum={6}
        TotalProductsPrice="$200"
      />
      <Routes>
        <Route
          path="/"
          element={<LandingPage />}
        />
        <Route
          path="/faq"
          element={<FaqPage />}
        />
        <Route
          path="/about"
          element={<AboutPage />}
        />
        <Route
          path="/contact"
          element={<ContactPage />}
        />
        <Route
          path="/shop"
          element={<ShopPage />}
        />
        <Route
          path="/product_details"
          element={<ProductDetail />}
        />
        <Route
          path="/privacy"
          element={<PrivacyPolicy />}
        />
        <Route
          path="/terms"
          element={<Terms />}
        />
        <Route
          path="/refund"
          element={<Refund />}
        />
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/signup"
          element={<SignUp />}
        />
        <Route
          path="/404"
          element={<ErrorPage />}
        />
        <Route
          path="/blog"
          element={<BlogPage />}
        />
        <Route
          path="/blog_details"
          element={<BlogDetailsPage />}
        />
        <Route
          path="/wishlist"
          element={<WhishListPage />}
        />
        <Route
          path="/cart"
          element={<CartPage />}
        />
        <Route
          path="/checkout"
          element={<CheckoutPage />}
        />
        <Route
          path="/comming_soon"
          element={<CommingSoon />}
        />
        <Route
          path="/empty_cart"
          element={<EmptyCartPage />}
        />
        <Route
          path="/empty_wishlist"
          element={<EmptyWishlist />}
        />
      </Routes>
      <Footer />
    </>
  )
}

export default App